import React from 'react';
import UiKit from '../../../uikit';

class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    createComponentClasses() {
        let {
            active,
            className
        } = this.props;

        let classNames      = ['marketkit-numeric-picker-wrapper-button active'];
        if (active)         classNames.push('active');
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render(){
        let { icon, onClick } = this.props;
        return(
            <div 
                className = { this.createComponentClasses() }
                onClick   = { (e) => onClick(e) }
            >
                <UiKit.Icon className="marketkit-numeric-picker-button-icon" icon={ icon } />
            </div>
        )
    }
}

export default Button;